"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)('[data-autosubmit=true]').click();
};

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/autoSubmit.js
// module id = 1056
// module chunks = 0